<template>
  <Modal v-model="show" title="添加成员" :closable="false" :mask-closable="false" width="600px">
    <Form ref="formData" :model="formData" :rules="rules" :label-width="100">
      <FormItem prop="user_type" label="账号类型：">
        <RadioGroup v-model="formData.user_type" @on-change="() => (formData.ids = [])">
          <Radio :label="1">学生</Radio>
          <Radio :label="2">教师</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="ids" label="账号：">
        <Select v-model="formData.ids" filterable :remote-method="handleSearch" :loading="searchLoading" multiple placeholder="请输入账号搜索">
          <Option v-for="(option, index) in accountList" :value="option.id" :key="index">{{ option.account }}</Option>
        </Select>
      </FormItem>
    </Form>
    <template #footer>
      <Button type="default" @click="show = false">取消</Button>
      <Button type="primary" @click="handleSubmit('formData')" :loading="loading">确定</Button>
    </template>
  </Modal>
</template>
<script>
import { Form, FormItem, Modal, Button, RadioGroup, Radio, Select, Option } from 'view-design'
export default {
  components: { Form, FormItem, Modal, Button, RadioGroup, Radio, Select, Option },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    project_id: {
      type: Number,
      required: true
    }
  },
  data() {
    const arrRequired = (rule, value, callback) => {
      if (value.length > 0) {
        callback()
      } else {
        callback(new Error('请选择账号'))
      }
    }
    return {
      formData: {
        ids: [],
        user_type: 1
      },
      loading: false,
      searchLoading: false,
      accountList: [],
      rules: {
        ids: [
          {
            validator: arrRequired,
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.handleOk()
        }
      })
    },
    async handleOk() {
      const params = {
        uriCode: 'ZP_API006',
        ...this.formData,
        project_id: this.project_id
      }

      try {
        this.loading = true
        await this.$fetch(params)
        this.show = false
        this.$emit('ok')
      } finally {
        this.loading = false
      }
    },
    async handleSearch(keyword) {
      console.log(keyword)
      const params = {
        uriCode: 'ZP_API005',
        account: keyword,
        index: 1,
        size: 1000,
        user_type: this.formData.user_type
      }
      try {
        this.searchLoading = true
        const res = await this.$fetch(params)
        this.accountList = res.list
      } finally {
        this.searchLoading = false
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (!val) {
        this.$refs['formData'].resetFields()
      } else {
        this.formData.name = this.createObj.name
        this.formData.life = this.createObj.life
      }
    }
  }
}
</script>
